import { Quote, Star } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const testimonials = [
  {
    id: "halcyon",
    quote: "Two attempted breaches in our first year — both intercepted before the fence line. The K9 compound teams paid for themselves in a single night.",
    name: "Operations Director",
    org: "Halcyon Logistics Park",
  },
  {
    id: "ironfence",
    quote: "Frontline rebuilt our entire access layer — fobs, cameras, gate guards — and tied it into one reporting feed. Our insurers cut our premium within a quarter.",
    name: "Estate Manager",
    org: "Ironfence Executive Estates",
  },
  {
    id: "northgate",
    quote: "Their risk audit found blind spots our previous provider walked past for three years. Ruthlessly thorough, and the alarm response is genuinely fast.",
    name: "Head of Facilities",
    org: "Northgate Industrial",
  },
];

const clients = ["Halcyon Logistics", "Ironfence Estates", "Northgate Industrial", "Vanta Freight", "Blackstone Assets", "Meridian Yards"];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 sm:py-32 bg-[#0F1115] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          testid="testimonials-heading"
          overline="Verified Intel"
          title="Trusted Where Failure Isn't an Option"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.1}>
              <blockquote
                data-testid={`testimonial-${t.id}`}
                className="h-full clip-corners bg-[#08090B] border border-white/10 hover:border-blue-500/40 p-8 flex flex-col gap-6 transition-colors duration-500"
              >
                <Quote className="w-7 h-7 text-blue-500" strokeWidth={1.5} />
                <p className="text-base text-gray-300 leading-relaxed flex-1">"{t.quote}"</p>
                <footer className="border-t border-white/5 pt-5">
                  <p className="font-display font-bold text-gray-100">{t.name}</p>
                  <p className="font-mono text-xs uppercase tracking-[0.2em] text-blue-500/90 mt-1">{t.org}</p>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-16">
          <div data-testid="client-logos-strip" className="flex flex-wrap items-center justify-center gap-x-12 gap-y-4 border-t border-white/5 pt-10">
            {clients.map((c) => (
              <span key={c} className="font-display font-bold uppercase tracking-[0.15em] text-gray-600 hover:text-gray-300 transition-colors duration-300 text-sm sm:text-base">
                {c}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.3} className="mt-12 text-center">
          <a
            data-testid="google-review-button"
            href="https://share.google/pWQSrk20dt9dsv3Wj"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 clip-corners border border-white/15 hover:border-blue-500/60 text-gray-200 hover:text-blue-400 font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 transition-colors duration-300"
          >
            <Star className="w-4 h-4 text-blue-500" />
            Leave us a Google review
          </a>
        </Reveal>
      </div>
    </section>
  );
}
